<template>
    <div class="user-config">
        <!-- 隐私设置 -->
        <div class="form-section">
            <h4 class="section-title">
                <i class="el-icon-lock"></i>
                隐私设置
            </h4>
            <div class="setting-item">
                <div class="setting-label">
                    <i class="el-icon-user-solid"></i>
                    <span>加我为好友时需要验证</span>
                </div>
                <div class="setting-content">
                    <el-switch v-model="userInfo.isManualApprove" @change="onManualApproveChange"></el-switch>
                </div>
            </div>
        </div>

        <!-- 通知设置 -->
        <div class="form-section">
            <h4 class="section-title">
                <i class="el-icon-bell"></i>
                通知设置
            </h4>
            <div class="setting-item">
                <div class="setting-label">
                    <i class="el-icon-microphone"></i>
                    <span>新消息提示音</span>
                </div>
                <div class="setting-content">
                    <el-switch v-model="userInfo.isAudioTip" @change="onMessageAudioTip"></el-switch>
                </div>
            </div>
        </div>

        <div class="form-section">
            <h4 class="section-title">
                <i class="el-icon-edit-outline"></i>
                聊天显示
            </h4>
            <div class="font-preview">
                <div class="line other">
                    <div class="bubble" :style="chatFontStyle">你好，这里可以预览聊天字体大小。</div>
                </div>
                <div class="line mine">
                    <div class="bubble" :style="chatFontStyle">拖动滑块即可实时调整显示效果。</div>
                </div>
                <div class="line other">
                    <div class="bubble" :style="chatFontStyle">当前字号：{{ chatFontSize }}px</div>
                </div>
            </div>
            <div class="slider-row">
                <span class="range-text">{{ minChatFontSize }}px</span>
                <el-slider v-model="chatFontSize" :min="minChatFontSize" :max="maxChatFontSize"
                    @input="onChatFontSizeInput" @change="onChatFontSizeChange"></el-slider>
                <span class="range-text">{{ maxChatFontSize }}px</span>
            </div>
            <div class="reset-row">
                <el-button size="mini" @click="onResetChatFontSize">恢复默认</el-button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "userConfig",
    data() {
        return {
            userInfo: {
                isManualApprove: false,
                isAudioTip: false
            },
            minChatFontSize: 12,
            maxChatFontSize: 22,
            defaultChatFontSize: 14,
            chatFontSize: 14
        }
    },
    computed: {
        chatFontStorageKey() {
            const uid = this.userStore.userInfo && this.userStore.userInfo.id;
            return uid ? `chats-web-${uid}-chatFontSize` : "";
        },
        chatFontStyle() {
            return { fontSize: `${this.chatFontSize}px` };
        }
    },
    methods: {
        init() {
            let mine = this.userStore.userInfo;
            this.userInfo = JSON.parse(JSON.stringify(mine));
            this.loadChatFontSize();
        },
        loadChatFontSize() {
            if (!this.chatFontStorageKey) {
                return;
            }
            const raw = Number(localStorage.getItem(this.chatFontStorageKey));
            this.chatFontSize = raw >= this.minChatFontSize && raw <= this.maxChatFontSize
                ? raw
                : this.defaultChatFontSize;
        },
        saveChatFontSize() {
            if (!this.chatFontStorageKey) return;
            localStorage.setItem(this.chatFontStorageKey, String(this.chatFontSize));
            this.$eventBus.$emit("chatFontSizeChanged", this.chatFontSize);
        },
        onChatFontSizeInput() {
            this.saveChatFontSize();
        },
        onChatFontSizeChange() {
            this.saveChatFontSize();
        },
        onResetChatFontSize() {
            this.chatFontSize = this.defaultChatFontSize;
            this.saveChatFontSize();
        },
        onManualApproveChange() {
            this.$http({
                url: "/user/manualApprove?enabled=" + this.userInfo.isManualApprove,
                method: 'put'
            }).then(() => {
                this.userStore.loadUser();
            })
        },
        onMessageAudioTip() {
            this.$http({
                url: "/user/audioTip?enabled=" + this.userInfo.isAudioTip,
                method: 'put'
            }).then(() => {
                this.userStore.loadUser();
            })
        }
    },
    watch: {
        // userStore 初始化晚于组件时，storage key 会从空变为有效值，这里自动补拉已保存字号
        chatFontStorageKey: {
            handler(newKey, oldKey) {
                if (newKey && newKey !== oldKey) {
                    this.loadChatFontSize();
                }
            },
            immediate: true
        }
    }
}
</script>
<style scoped lang="scss">
.user-config {
    padding: 15px;
    background: #fafbfc;
    min-height: 400px;

    // 表单区域
    .form-section {
        background: white;
        border-radius: 8px;
        padding: 15px;
        margin-bottom: 12px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
        border: 1px solid #f0f0f0;

        .section-title {
            margin: 0 0 15px 0;
            font-size: var(--im-font-size-larger);
            font-weight: 600;
            display: flex;
            align-items: center;
            gap: 6px;
            padding-bottom: 8px;
            border-bottom: 1px solid #f5f5f5;

            i {
                color: var(--im-color-primary);
                font-size: 16px;
            }
        }
    }

    // 设置项
    .setting-item {
        display: flex;
        align-items: center;
        padding: 12px 0;
        border-bottom: 1px solid #f5f5f5;

        &:last-child {
            border-bottom: none;
        }

        .setting-label {
            flex: 1;
            display: flex;
            align-items: center;
            gap: 8px;
            width: 100px;
            font-weight: 500;
            color: var(--im-text-color-light);
            font-size: var(--im-font-size);

            i {
                color: var(--im-color-primary);
                font-size: var(--im-font-size-large);
            }
        }

        .setting-content {
            flex: 1;
            display: flex;
            justify-content: flex-end;
        }
    }

    .font-preview {
        background: #f5f7fb;
        border-radius: 8px;
        padding: 12px;
        margin-bottom: 12px;

        .line {
            display: flex;
            margin-bottom: 8px;

            &:last-child {
                margin-bottom: 0;
            }

            &.mine {
                justify-content: flex-end;

                .bubble {
                    background: var(--im-color-primary-light-2);
                    color: #fff;
                }
            }

            .bubble {
                max-width: 70%;
                padding: 8px 10px;
                border-radius: 8px;
                background: #fff;
                color: var(--im-text-color);
                line-height: 1.6;
            }
        }
    }

    .slider-row {
        display: flex;
        align-items: center;
        gap: 10px;

        .el-slider {
            flex: 1;
        }

        .range-text {
            color: var(--im-text-color-light);
            font-size: var(--im-font-size-small);
            width: 36px;
            text-align: center;
        }
    }

    .reset-row {
        margin-top: 10px;
        text-align: right;
    }
}
</style>
